import { useClipboard as useNativeClipboard } from 'use-clipboard-copy';

export const useClipboard = () => useNativeClipboard();
